import React from 'react';
import TableRow from './TableRow';

function TableBody({
    data,
    columns,
    visibleColumns,
    sliceStart,
    selectedRows,
    selectable,
    onToggleSelect,
    onRowClick,
    onImageClick,
    onTextOverflow,
    conditionalFormats,
    stickyOffsets,
    getRowKey,
    loading,
}) {
    if (loading) {
        return (
            <tbody className="ut-tbody">
                <tr>
                    <td colSpan={visibleColumns.length + 1} className="ut-td ut-td--loading">
                        <div className="ut-loading">
                            <span className="spinner" aria-hidden="true" />
                            Загрузка...
                        </div>
                    </td>
                </tr>
            </tbody>
        );
    }

    if (!data.length) {
        return (
            <tbody className="ut-tbody">
                <tr>
                    <td colSpan={visibleColumns.length + 1} className="ut-td ut-td--empty">
                        <div className="ut-empty">Нет данных</div>
                    </td>
                </tr>
            </tbody>
        );
    }

    return (
        <tbody className="ut-tbody">
            {data.map((row, index) => {
                const rowKey = getRowKey
                    ? getRowKey(row, index)
                    : (Array.isArray(row) ? `row-${sliceStart + index}` : (row.id || `row-${sliceStart + index}`));
                const isSelected = selectedRows.includes(rowKey);

                return (
                    <TableRow
                        key={rowKey}
                        row={row}
                        rowIndex={sliceStart + index}
                        columns={columns}
                        visibleColumns={visibleColumns}
                        rowKey={rowKey}
                        sliceStart={sliceStart}
                        isSelected={isSelected}
                        selectable={selectable}
                        onToggleSelect={onToggleSelect}
                        onRowClick={onRowClick}
                        onImageClick={onImageClick}
                        onTextOverflow={onTextOverflow}
                        conditionalFormats={conditionalFormats}
                        stickyOffsets={stickyOffsets}
                    />
                );
            })}
        </tbody>
    );
}

export default React.memo(TableBody);
